import { Secret } from 'kubernetes-types/core/v1';

export function getSecret(secrets?: Secret[], volumeConfigName?: string) {
  return secrets?.find((secret) => secret.metadata?.name === volumeConfigName);
}
